// Real Time Table suggestive word/key
export const dynamicRows = ['status']
export const realTimeTableKey = 'GetDataByUser'

import i18n from '@/i18n'

export const dynamicColumns = [
    {
        prop: 'online_user_id',
        fixed: false,
        align: 'center',
        label: i18n.t('widget.realtimeTable.column.online_user_id'),
    },
    {
        prop: 'representant',
        fixed: false,
        align: 'center',
        label: i18n.t('widget.realtimeTable.column.representant'),
    },
    {
        prop: 'user_name',
        fixed: false,
        align: 'center',
        label: i18n.t('widget.realtimeTable.column.user_name'),
    },
    {
        prop: 'extension_name',
        fixed: false,
        align: 'center',
        label: i18n.t('widget.realtimeTable.column.extension_name'),
    },
    {
        prop: 'extension_id',
        fixed: false,
        align: 'center',
        label: i18n.t('widget.realtimeTable.column.extension_id'),
    },
    {
        prop: 'status',
        fixed: false,
        align: 'center',
        label: i18n.t('widget.realtimeTable.column.status'),
    },
    {
        prop: 'status_duration',
        fixed: false,
        align: 'center',
        label: i18n.t('widget.realtimeTable.column.status_duration'),
        width: '250px',
    },
    {
        prop: 'caller_info',
        fixed: false,
        align: 'center',
        label: i18n.t('widget.realtimeTable.column.caller_info'),
        sortable: false,
    },
    {
        prop: 'call_info',
        fixed: false,
        align: 'center',
        label: i18n.t('widget.realtimeTable.column.call_info'),
        sortable: false,
    }
]
